(() => {
  const selector = document.querySelector('[data-mdf-language]');
  if (!selector) return;
  const form = selector.querySelector('form');
  if (!form) return;
  // Section rendering must not become the destination after a language change.
  const setReturnPath = () => {
    const params = new URLSearchParams(location.search);
    params.delete('section_id');
    params.delete('sections');
    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo);
    }
    returnTo.value = location.pathname + (params.size ? '?' + params.toString() : '');
  };
  setReturnPath();
  form.addEventListener('submit', setReturnPath);
  document.addEventListener('click', event => { if (!selector.contains(event.target)) selector.open = false; });
  selector.addEventListener('keydown', event => {
    if (event.key === 'Escape') { selector.open = false; selector.querySelector('summary').focus(); }
  });
})();
